import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, FormGroup, Container, Label } from 'reactstrap';
import * as elements from '../data/Elements';
import DropdownSelection from '../data/DropDown';
import * as Studies from '../store/Studies';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';



class CreateRecordCrfQa extends React.Component {
    constructor(props) {
        super(props);

        const create = utility.propCheck(props.create, false);
        const disabled = utility.propCheck(props.disabled, false);
        const handleKeyDown = utility.propCheck(props.handleKeyDown, null);
        const saveButton = utility.propCheck(props.saveButton, false);
        const serviceType = utility.propCheck(props.serviceType, "Unknown");
        const studyId = utility.propCheck(props.studyId, "Unknown");
        const handleCrfQnA = utility.propCheck(props.handleCrfQnA, "Unknown");

		var crfQnA = [];
		if ( ! create ) {
			crfQnA = this.storeCrfQnA(studyId);
		}

        this.state = {
			crfQnA_original: crfQnA,
			crfQnA: crfQnA,
			handleCrfQnA: handleCrfQnA,
			studyId: studyId,
            create: create,
            disabled: disabled,
            editing: !disabled,
            edited: false,
            handleKeyDown: handleKeyDown,
            saveButton: saveButton,
            serviceType: serviceType,
        };

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
	}

	storeCrfQnA( studyId ) {
        var crfQnA = this.props.recordsState && this.props.recordsState.record && this.props.recordsState.record.record && this.props.recordsState.record.record.crfQnA;

		if ( crfQnA === null || crfQnA === undefined || ((typeof crfQnA === 'string' || crfQnA instanceof String) && crfQnA.length === 0 ) ) {

            (async () => {
                await this.props.studiesDispatch.get(studyId);
			})().then(() => {
				var stud = this.props.studiesState.study;

				var crfQnaEvent = stud && stud.crfQnaEvent;
				var crfQnaHolter = stud && stud.crfQnaHolter;
				var crfQna12Lead = stud && stud.crfQna12Lead;

				switch ( this.props.serviceType ) {
					case Records.recordServiceTypes.event:
						crfQnA = crfQnaEvent;
						break;
					case Records.recordServiceTypes.holter:
						crfQnA = crfQnaHolter;
						break;
					case Records.recordServiceTypes.twelveLead:
						crfQnA = crfQna12Lead;
						break;
					default:
						break;
				}

				if ( typeof crfQnA === 'string' || crfQnA instanceof String ) {
					crfQnA = JSON.parse(crfQnA);
				}
				this.setState({
					crfQnA: crfQnA,
					crfQnA_original: crfQnA
				});
				return crfQnA;
			});

		} else {

			if ( typeof crfQnA === 'string' || crfQnA instanceof String ) {
				crfQnA = JSON.parse(crfQnA);
			}
			return crfQnA;
		}
	}


    handleSave() {

		/* send this.state.crfQnA to the database thru the API, or just into the parent's data structure (if this is a brand new record) */

		const recordRecord = this.props.recordsState.record.record;

		if ( recordRecord.id ) {
			/* save this each time, since we know what Record.id this is, and the user may not choose to hit Save on the whole Record to record this change. */
			this.props.recordsDispatch.updateRecordCrf( this.state.serviceType, recordRecord.id, this.state.crfQnA );
		} else {
			/* only save this when the whole Record gets created, as we don't have a Record.id until then */
			const record = this.props.recordsState.record;
			record.crfQnA = this.state.crfQnA;
		}

		this.setState({ crfQnA_original: this.state.crfQnA });	/* remember this saved CRF data */

		if ( this.state.handleCrfQnA ) {
			this.state.handleCrfQnA( this.state.serviceType, this.state.crfQnA );
		}

		if (this.state.edited) {
			this.setState({
				edited: false
			});
		}
    }


    handleCancel() {

		this.setState({ crfQnA: this.state.crfQnA_original });	/* reset the CRF data */
		this.hideDependentQuestions( this.state.crfQnA_original );

		if (this.state.edited) {
			this.setState({
				edited: false
			});
		}
    }


	hideDependentQuestions( theCrfQnA ) {

		if ( theCrfQnA === null || theCrfQnA === undefined || ! theCrfQnA ) {
			return;
		}

		for ( var i = 0 ; i < theCrfQnA.length ; i++ ) {
			const curQ = theCrfQnA[i];

			document.getElementById("q_" + curQ.id).style.display = "block";

			if ( curQ.dependsOnWhichId >= 0 ) {
				const parentQ = theCrfQnA[curQ.dependsOnWhichId];

				if ( curQ.hideWhenAnswerIs && (curQ.hideWhenAnswerIs.trim() === (parentQ.answerText && parentQ.answerText.trim())) ) {
					document.getElementById("q_" + curQ.id).style.display = "none";
				}
			}
		}
	}


	handleCheckboxValue = idx => evt => {

		const theId = parseInt(evt.target.name.split("_")[1], 10);
		const theChoiceIdx = parseInt(evt.target.name.split("_")[2], 10 );

		const newCrfQnA = this.state.crfQnA.map((theQ) => {
			if (theId === theQ.id) {
				const theChoice = theQ.multipleChoices.split("|")[theChoiceIdx].trim();

				let variousAnswers = theQ.answerText && (theQ.answerText.split("|")).map(Function.prototype.call, String.prototype.trim);

				let ans = null;
				if ( variousAnswers && variousAnswers.includes(theChoice) ) {
					ans = variousAnswers.filter(function (el) { return el !== theChoice; }).join("|");
				} else {
					if ( ! theQ.answerText || theQ.answerText === undefined || theQ.answerText.length === 0 ) {
						ans = theChoice;
					} else {
						ans = theQ.answerText + "|" + theChoice;
					}
				}
				return { ...theQ, answerText: ans };
			} else {
				return theQ;
			}
		});

		this.hideDependentQuestions( newCrfQnA );

		this.setState({ crfQnA: newCrfQnA });

        if ( ! this.state.edited ) {
            this.setState({
                edited: true
            });
        }
	};

	handleRadioValue = idx => evt => {

		const theId = parseInt(evt.target.name.split("_")[1], 10);
		const theChoiceIdx = parseInt(evt.target.name.split("_")[2], 10 );

		const newCrfQnA = this.state.crfQnA.map((theQ) => {
				if (theId === theQ.id) {
					return { ...theQ, answerText: theQ.multipleChoices.split("|")[theChoiceIdx] };
				} else {
					return theQ;
				}
			});

		this.hideDependentQuestions( newCrfQnA );

		this.setState({ crfQnA: newCrfQnA });

        if ( ! this.state.edited ) {
            this.setState({
                edited: true
            });
        }
	};

	handleDropdownValue = idx => theChoice => {

		let theChoiceStr = theChoice.join("|");

		const newCrfQnA = this.state.crfQnA.map((theQ) => {
				if (idx === theQ.id) {
					return { ...theQ, answerText: theChoiceStr };
				} else {
					return theQ;
				}
			});

		this.hideDependentQuestions( newCrfQnA );

		this.setState({ crfQnA: newCrfQnA });

        if ( ! this.state.edited ) {
            this.setState({
                edited: true
            });
        }
	};


	handleAnswerChange = idx => evt => {

		const newCrfQnA = this.state.crfQnA.map((theQ, sidx) => {
				if (idx !== sidx) return theQ;
					return { ...theQ, answerText: evt.target.value };
				});

		this.setState({ crfQnA: newCrfQnA });

		/* if this is a newly created Record, then send this up to the parent to get saved when the whole Record gets saved/created */
		if ( this.state.create ) {
			const record = this.props.recordsState.record;
			record.crfQnA = newCrfQnA;
			this.props.recordsDispatch.set(record);
		}

        if ( ! this.state.edited ) {
            this.setState({
                edited: true
            });
        }
	};


	componentDidUpdate() {
		this.hideDependentQuestions( this.state.crfQnA );
	}

	componentDidMount() {
		const studyId = utility.propCheck(this.state.studyId, "Unknown");
		this.storeCrfQnA( studyId );
	}

    render() {

        const editing = this.state.editing && ! this.props.disabled;
        const edited = this.state.edited;
        const create = this.state.create;
        const save = "Save";
        const cancel = "Cancel";

		let radioButtons = (theQ,idx) => {
			if ( theQ.multipleChoices ) {
				const arrChoices = theQ.multipleChoices.split("|");
				const arrValues = theQ.answerText && theQ.answerText.split("|");
				const choiceCnt = arrChoices.length;
				if ( theQ.multipleChoicesType === elements.multipleChoiceTypes.checkbox ) {
					const variousAnswers = theQ.answerText && (theQ.answerText.split("|")).map(Function.prototype.call, String.prototype.trim);
					if ( choiceCnt > 5 ) {
						const classNameInput = "crfDependency crfAnswerParent crfDropdown";
						return <DropdownSelection id={"dropdown_"+idx} isCheckboxes={true} disabled={!editing} className={classNameInput} values={arrValues} selections={arrChoices} onSelect={this.handleDropdownValue(idx)} />;
					} else {
						return theQ.multipleChoices.split("|").map((theChoice, idx) => (
							elements.getCheckboxInput( "choice_" + theQ.id + "_" + idx, (variousAnswers && variousAnswers.includes(theChoice.trim())), !editing, this.handleCheckboxValue(idx), this.state.handleKeyDown, theChoice )
							)
						);
					}
				} else {
					if ( choiceCnt > 3 ) {
						const classNameInput = "crfDependency crfAnswerParent crfDropdown";
						return <DropdownSelection id={"dropdown_"+idx} isCheckboxes={false} disabled={!editing} className={classNameInput} values={arrValues} selections={arrChoices} onSelect={this.handleDropdownValue(idx)} />;
					} else {
						return theQ.multipleChoices.split("|").map((theChoice, idx) => (
							elements.getRadioInput( "choice_" + theQ.id + "_" + idx, (theQ.answerText && theQ.answerText.trim()) === theChoice.trim(), !editing, this.handleRadioValue(idx), this.state.handleKeyDown, theChoice )
							)
						);
					}
				}
			} else {
				return elements.getInput("crfQaQuestion_"+theQ.id + "_" + idx, !editing, this.handleAnswerChange(idx), this.state.handleKeyDown, elements.inputTypes.text, theQ.answerText)
			}
		};


        return (
			<Container className="gap gap-bottom group-border" fluid>
				<h4 className="center">{this.state.serviceType} CRF</h4>

				<div>
					{this.state.crfQnA && this.state.crfQnA.map((theQ, idx) => (
						<div id={"q_" + theQ.id} key={theQ.id}>
						<FormGroup tag="fieldset" className="dark">
							<Label for={"lbl_" + theQ.id}>{theQ.questionText}</Label>
							{radioButtons(theQ,idx)}
						</FormGroup>
						</div>
					))}
				</div>
                {edited && ! create && (
					<FormGroup tag="fieldset" className="light">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
					</FormGroup>
                )}
            </Container>
        );
	}
}

export default connect(
    state => ({
        studiesState: state.studies,
        recordsState: state.records
    }),
    dispatch => ({
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(CreateRecordCrfQa);



// WEBPACK FOOTER //
// ./src/components/CreateRecordCrfQa.js